<script>
import api from '@/api/project';

import BaseInput from '@/components/BaseInput.vue';
import EmptyList from '@/components/ui/EmptyList.vue';

// Выбор шаблона проекта. Резолвится выбранный шаблон, false — при закрытии.
export default {
  name: 'ProjectTemplateSelectPopupWrappable',
  components: { BaseInput, EmptyList },
  data() {
    return {
      project: null,
      items: [],
      isLoaded: false,
      search: '',
    };
  },
  computed: {
    filteredItems() {
      const str = this.search.trim().toLowerCase();
      return this.items.filter(t => !str || t.name.toLowerCase().includes(str));
    },
  },
  methods: {
    async init({ project }) {
      this.project = project;

      const r = await api.fetchList({ isTemplate: true, isArchived: false }, true);
      // сам проект тоже может быть шаблоном — применять его к себе бессмысленно
      this.items = r.items.filter(t => t.id !== project.id);
      this.isLoaded = true;
    },
    select(template) {
      this.$emit('finish', template);
    },
  },
};
</script>

<template lang="pug">
  .b-project-template-select-popup
    ._title Применить шаблон
    template(v-if="isLoaded")
      EmptyList(v-if="!items.length" label="Нет доступных шаблонов")
      template(v-else)
        BaseInput._search(v-model="search" iconName="search" label="Поиск")
        ._items
          ._item(v-for="template in filteredItems" :key="template.id")
            ._name {{ template.name }}
            ._department(v-if="template.companyDepartment") {{ template.companyDepartment.company.name }}, {{ template.companyDepartment.name }}
            Btn._apply(sm green @click="select(template)") Применить
          EmptyList(v-if="!filteredItems.length" label="Ничего не найдено")
</template>

<style scoped lang="scss">
.project-template-select-popup {
  width: 650px;
  max-width: calc(100vw - 115px);

  &__title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 30px;
  }

  &__search {
    margin-bottom: 20px;
  }

  &__items {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 50vh;
    overflow-y: auto;
  }

  &__item {
    display: grid;
    grid-template-columns: 1fr auto;
    column-gap: 15px;
    align-items: center;
    padding: 10px 14px;
    background: var(--main-bg);
    border-radius: 6px;
  }

  &__name {
    font-weight: 700;
  }

  &__department {
    font-size: 13px;
    color: var(--color-middle-gray);
  }

  &__apply {
    grid-column: 2;
    grid-row: 1 / 2 span;
  }

  @media (max-width: 767px) {
    &__item {
      grid-template-columns: 1fr;
    }

    &__apply {
      grid-column: 1;
      grid-row: auto;
      margin-top: 10px;
    }
  }
}
</style>
